
/** Styles pour l'export Excel avec table-to-excel (surcouche de exceljs) : 
 * attributs à ajouter aux éléments html plutôt que des classes, 
 * cf. documentation https://github.com/linways/table-to-excel 
 * */
export const excelStyles = {
  colors: {
    primary: "0118b2",
    primary80pc: "3446c1",
    primary60pc: "6774d1",
    primary40pc: "99a3e0",
    textColorAlt: "f2f5f8"
  },
  /** Styles de base pour tous les <td> */
  baseTdAttr: {
    // Horizontal alignment
    "data-a-h": "center",
    // Vertical alignment
    "data-a-v": "middle",
    // Borders
    "data-b-a-s": "thin",
    // Wrap words
    "data-a-wrap": "true",
  },
  /** Styles de base pour tous les <th> 
   * Attention : les <th> gérés dans TableRenderer (table header, totaux etc) ne prévoient d'accepter que 8 attributs,
   * adapter le TableRenderer si besoin de plus
  */
  baseThAttr: {
    // Horizontal alignment
    "data-a-h": "center",
    // Vertical alignment
    "data-a-v": "middle",
    // Borders
    "data-b-a-s": "thin",
    // Wrap words
    "data-a-wrap": "false",
    // Font size
    //"data-f-sz": "14",
    "data-f-bold": "true",
    // Background color
    "data-fill-color": "0118b2",//this.colors.primary,
    // Font color
    "data-f-color": "f2f5f8",//this.colors.textColorAlt,
    // Border color
    "data-b-a-c": "f2f5f8",//this.colors.textColorAlt
  },

  /** Calcule les attributs à appliquer à chaque cellule de type td,
   * en complétant les attributs déjà existants sur la colonne
   */
  getTdAttr(col, item) {
    let tdAttr = col.tdAttr
      ? { ...col.tdAttr, ...this.baseTdAttr }
      : this.baseTdAttr;

    if (col.tdClass) {
      if (col.tdClass.includes("col-total")) {
        tdAttr["data-f-color"] = this.colors.textColorAlt;
        if (col.tdClass.includes("col-total-max")) {
          tdAttr["data-fill-color"] = this.colors.primary;
          tdAttr["data-f-bold"] = "true";
        } else {
          tdAttr["data-fill-color"] = this.colors.primary80pc;
        }
      }
    }
    if (item && item.groupLevel !== undefined) {
      tdAttr["data-f-color"] = this.colors.textColorAlt;
      switch (item.groupLevel) {
        case -1:
          tdAttr["data-fill-color"] = this.colors.primary;
          break;
        case 0:
          tdAttr["data-fill-color"] = this.colors.primary80pc;
          break;
        case 1:
          tdAttr["data-fill-color"] = this.colors.primary60pc;
          break;
        case 2:
          tdAttr["data-fill-color"] = this.colors.primary40pc;
          break;
        default:
          break;
      }
    }
    return tdAttr;
  },

  /** Calcule les attributs à appliquer à chaque cellule de type th,
   * en complétant les attributs déjà existants sur la colonne
   */
  getThAttr(col, item) {
    return col.thAttr
      ? { ...col.thAttr, ...this.baseThAttr }
      : this.baseThAttr;
  }
};